import 'lightslider';

var $homeSlider;

export function init (el) {
  $homeSlider = $(el);

  $homeSlider.lightSlider({
    // gallery: slidesCount > 1,
    auto: true,
    pager: false,
    // controls: slidesCount > 1,
    item: 1,
    loop: true,
    // thumbItem: 6,
    adaptiveHeight: true,
    mode: 'fade',
    speed: $homeSlider.data('speed'),
    pause: $homeSlider.data('pause'),
    enableDrag: false,
    // enableDrag: false,
    // currentPagerPosition:'left',
    onSliderLoad () {
      $homeSlider.removeClass('cS-hidden');
    }
  });
}
